module.exports = __webpack_public_path__ + "img/align_vertical.fe7e2e3a.svg";